/**
 * Regex matching an ISO date (YYYY-MM-DD)
 * @see {@link isIsoDate}
 */
export const isoDateRegex = /^\d{4}-(?:0[1-9]|1[012])-(?:0[1-9]|[12]\d|3[01])$/;
/**
 * Check if a string is an ISO date (YYYY-MM-DD)
 */
export function isIsoDate(date) {
    return !!date.match(isoDateRegex);
}
/**
 * Regex matching an ISO datetime (YYYY-MM-DDTHH:MM:SS[.mmm](Z|+HH:MM))
 * @see {@link isIsoDateTime}
 */
export const isoDateTimeRegex = /^\d{4}-(?:0[1-9]|1[012])-(?:0[1-9]|[12]\d|3[01])T(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d|60)(?:\.\d+)(?:Z|[+-]\d{2}:\d{2})$/;
/**
 * Check if a string is an ISO datetime (YYYY-MM-DDTHH:MM:SS[.mmm](Z|+HH:MM))
 */
export function isIsoDateTime(date) {
    return !!date.match(isoDateTimeRegex);
}
/**
 * Regex matching an ISO local time (HH:MM:SS[.mmm])
 * @see {@link isIsoLocalTime}
 */
export const isoLocalTimeRegex = /^(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d|60)(?:\.\d+)$/;
/**
 * Check if a string is an ISO local time (HH:MM:SS[.mmm])
 */
export function isIsoLocalTime(time) {
    return !!time.match(isoLocalTimeRegex);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2suanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiY2hlY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLG1EQUFtRCxDQUFBO0FBRS9FOztHQUVHO0FBQ0gsTUFBTSxVQUFVLFNBQVMsQ0FBQyxJQUFZO0lBQ3JDLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsWUFBWSxDQUFDLENBQUE7QUFDbEMsQ0FBQztBQUNEOzs7R0FHRztBQUNILE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUM1Qiw4SEFBOEgsQ0FBQTtBQUUvSDs7R0FFRztBQUNILE1BQU0sVUFBVSxhQUFhLENBQUMsSUFBWTtJQUN6QyxPQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLGdCQUFnQixDQUFDLENBQUE7QUFDdEMsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUM3Qix5REFBeUQsQ0FBQTtBQUUxRDs7R0FFRztBQUNILE1BQU0sVUFBVSxjQUFjLENBQUMsSUFBWTtJQUMxQyxPQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLGlCQUFpQixDQUFDLENBQUE7QUFDdkMsQ0FBQyJ9